/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Type of building export format
 */
export type BuildingExportType = 'BUILDING_EXPORT_LIST' | 'BUILDING_EXPORT_LIST_WITH_OWNERS';

export const BuildingExportType = {
    LIST: 'BUILDING_EXPORT_LIST' as BuildingExportType,
    LIST_WITH_OWNERS: 'BUILDING_EXPORT_LIST_WITH_OWNERS' as BuildingExportType
};

